import React from "react";
import css from "./index.module.scss";
import Button from "@/components/button";


export default function Fold1Section({
  headline = "",
  subheadline = "",
  image = null,
  className = "",
}) {
  return <section className={`section ${css.fold} ${className}`}>
    <div className="sectionInner">
      <div className={css.left}>
        <h2>{headline}</h2>
        <div className={css.subheadline}>{subheadline}</div>
        <Button label="Let's Talk" color="purple" className={css.cta} href="#contact"/>
      </div>
      <div className={css.right}>{image}</div>
    </div>
  </section>;
}
